import ProductScreen from './index';
import DetailScreen from './detail';
import CreateScreen from './create';
import UpdateScreen from './update';

const routes = [
  {
    path: '/master/product',
    component: ProductScreen,
  },
  {
    path: '/master/product/create',
    component: CreateScreen,
  },
  {
    path: '/master/product/:id',
    component: DetailScreen,
  },
  {
    path: '/master/product/:id/update',
    component: UpdateScreen,
  },
];

export default routes;
